import React from "react";
import { SvgIcon } from "@mui/material";

const normalizeProvider = (provider) => {
  const value = String(provider || "").trim().toLowerCase();

  if (value === "gmail") {
    return "gmail";
  }

  if (value === "personal_mailbox" || value === "webmail") {
    return "webmail";
  }

  return "email";
};

export const inferEmailProvider = (source = null) => {
  if (!source) {
    return "email";
  }

  if (typeof source === "string") {
    return normalizeProvider(source);
  }

  const directProvider = normalizeProvider(
    source?.provider
      || source?.metadata?.provider
      || source?.mailbox?.provider
      || source?.userMailbox?.provider
  );

  if (directProvider !== "email") {
    return directProvider;
  }

  if (source?.mailbox?.email_address || source?.userMailbox?.email_address || source?.user_mailbox_id) {
    return "webmail";
  }

  return "email";
};

export const emailProviderLabel = (provider) => {
  switch (inferEmailProvider(provider)) {
    case "gmail":
      return "Gmail";
    case "webmail":
      return "Webmail";
    default:
      return "Email";
  }
};

function GmailIcon({ sx }) {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={sx}>
      <path fill="#EA4335" d="M4 6.2 12 12l8-5.8V18a2 2 0 0 1-2 2h-1.3V9.7L12 13 7.3 9.7V20H6a2 2 0 0 1-2-2V6.2Z" />
      <path fill="#4285F4" d="M4 6.2V18a2 2 0 0 0 2 2h1.3V9.7L4 6.2Z" />
      <path fill="#34A853" d="M16.7 9.7V20H18a2 2 0 0 0 2-2V6.2l-3.3 3.5Z" />
      <path fill="#FBBC04" d="M20 6.2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v.2L12 12l8-5.8Z" />
    </SvgIcon>
  );
}

function WebmailIcon({ sx }) {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={sx}>
      <rect x="3" y="4" width="18" height="16" rx="3" fill="#EAF5EE" />
      <path fill="#2DB838" d="M3 8.4h18V7a3 3 0 0 0-3-3H6A3 3 0 0 0 3 7v1.4Z" />
      <circle cx="6.6" cy="6.2" r="0.8" fill="#FFFFFF" />
      <circle cx="9.2" cy="6.2" r="0.8" fill="#FFFFFF" />
      <circle cx="11.8" cy="6.2" r="0.8" fill="#FFFFFF" />
      <rect x="6" y="10.4" width="12" height="6.8" rx="1.4" fill="#1E88E5" />
      <path fill="#FFFFFF" d="M6.9 11.6 12 14.9l5.1-3.3v1.2L12 16l-5.1-3.2v-1.2Z" />
      <path fill="#CDE7FF" d="M6.9 11.6h10.2L12 14.9l-5.1-3.3Z" />
    </SvgIcon>
  );
}

function GenericEmailIcon({ sx }) {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={sx}>
      <path
        fill="currentColor"
        d="M5 6.5h14A2.5 2.5 0 0 1 21.5 9v6A2.5 2.5 0 0 1 19 17.5H5A2.5 2.5 0 0 1 2.5 15V9A2.5 2.5 0 0 1 5 6.5Zm0 1.5a1 1 0 0 0-.6.2L12 13.2l7.6-5a1 1 0 0 0-.6-.2H5Zm15 2-7.5 4.9a.9.9 0 0 1-1 0L4 10v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5Z"
      />
    </SvgIcon>
  );
}

export default function EmailProviderIcon({ provider = "email", size = 18, sx = {} }) {
  const normalizedProvider = inferEmailProvider(provider);
  const sharedSx = { fontSize: size, ...sx };

  switch (normalizedProvider) {
    case "gmail":
      return <GmailIcon sx={sharedSx} />;
    case "webmail":
      return <WebmailIcon sx={sharedSx} />;
    default:
      return <GenericEmailIcon sx={sharedSx} />;
  }
}
